export default ($) => {
  const INITIAL_VISIBLE_ITEMS = 1000;
  const LOAD_MORE_INCREMENT = 2;

  const initialParams = new URLSearchParams(window.location.search);

  const $filterForms = $('.js-filterForm');
  const $filterResults = $('.js-filterResults');

  if (!$filterForms.length || !$filterResults.length) return;

  $filterForms.each(function () {
    const $filterForm = $(this);

    const $filters = $filterForm.find('select, input[type=radio], input[type=checkbox]');
    const $filterSearch = $filterForm.find('input[name=search]');
    const $resetBtn = $filterForm.find('.js-filterReset');
    const $loadMoreBtn = $filterResults.find('.js-loadMoreFilters');
    const $filterItems = $filterResults.find('.js-filterItem');
    const facultyStaffFilter = $('.js-toggleSpecificFilter');
    const specificFilter = $('.js-specificFilter');

    let _filters = [];
    let visibleItems = INITIAL_VISIBLE_ITEMS;

    const NO_RESULTS_HTML = `
      <div class="_subhead no-results-message _12">
        No results. Try adapting or resetting filters.
      </div>
    `;

    let resetFilters = () => {
      const cleanUrl = window.location.origin + window.location.pathname;

      window.location.href = cleanUrl;
    };

    const initializeFiltersFromURL = () => {
      _filters = [];

      initialParams.forEach((value, name) => {
        if (value && value !== "") {
          _filters.push({ name, value });
        }
      });

      $filters.each(function () {
        const $filter = $(this);
        const name = $filter.attr('name');
        const matchingFilter = _filters.find(filter => filter.name === name);

        if (matchingFilter) {
          if ($filter.is('select')) {
            $filter.val(matchingFilter.value);
          } else if ($filter.is(':radio, :checkbox')) {
            $filter.prop('checked', $filter.val() === matchingFilter.value);
          }
        }
      });

      const searchFilter = _filters.find(filter => filter.name === $filterSearch.attr('name'));
      if (searchFilter) {
        $filterSearch.val(searchFilter.value);
      }
    };

    initializeFiltersFromURL();

    const updateQueryParams = () => {
      const params = new URLSearchParams();

      _filters.forEach(filter => {
        if (filter.value) {
          params.set(filter.name, filter.value);
        }
      });

      if (params.toString()) {
        history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
      } else {
        history.replaceState(null, '', window.location.pathname);
      }
    };

    const updateFilterState = ($filter) => {
      const name = $filter.attr('name');
      const value = $filter.is(':checkbox, :radio') ? ($filter.is(':checked') ? $filter.val() : null) : $filter.val();

      _filters = _filters.filter(f => f.name !== name);

      if (value && value !== '') {
        _filters.push({ name, value });
      }
    };

    const applyFilters = () => {
      let totalMatchingCount = 0; // Track the number of items that match filters
      let visibleCount = 0;       // Count items we are showing

      // Remove any existing 'No Results' message
      $filterResults.find('.no-results-message').remove();

      $filterItems.each(function () {
        const $item = $(this);
        let matches = true;

        // Check filters other than search
        _filters.forEach(filter => {
          if (filter.name !== 'search') {
            if (!$item.hasClass(filter.value)) {
              matches = false;
            }
          }
        });

        // Check search filter
        const searchFilter = _filters.find(filter => filter.name === 'search');
        if (searchFilter) {
          const searchValue = searchFilter.value.toLowerCase();
          const itemText = $item.text().toLowerCase();
          if (!itemText.includes(searchValue)) {
            matches = false;
          }
        }

        // Count total matching items
        if (matches) {
          totalMatchingCount++;

          if (visibleCount < visibleItems) {
            $item.show();
            visibleCount++;
          } else {
            $item.hide();
          }
        } else {
          $item.hide();
        }
      });

      if (totalMatchingCount === 0) {
        $filterResults.append(NO_RESULTS_HTML);
        $loadMoreBtn.hide();
      } else {
        if (visibleCount < totalMatchingCount) {
          $loadMoreBtn.show();
        } else {
          $loadMoreBtn.hide();
        }
      }

      updateQueryParams();
    };

    applyFilters();

    $loadMoreBtn.on('click', function () {
      visibleItems += LOAD_MORE_INCREMENT;
      applyFilters();
    });

    $filters.on('change', function () {
      updateFilterState($(this));
      applyFilters();
    });

    $filterSearch.on('input cut change keyup blur', function () {
      updateFilterState($(this));
      applyFilters();
    });

    $resetBtn.on('click', function (e) {
      e.preventDefault();
      resetFilters();
    });

    facultyStaffFilter.on('change', function () {
      let $_this = $(this);
      let $thisData = $_this.val();

      if (!$_this.is(':checked')) {
        $thisData = '';
      }

      specificFilter.hide().each(function () {
        let $firstDisabledLi = $(this).find('li.disabled').first();
        let selectStyled = $(this).find('div.select-styled').first();

        if ($firstDisabledLi.length) {
          $firstDisabledLi.trigger('click');
        }

        if (selectStyled.length) {
          selectStyled.removeClass('hasValue');
          selectStyled.text($thisData === 'faculty' ? 'Department' : 'Office');
        }
      });

      if (!$thisData) return;

      specificFilter.filter(`[data-specific="${$thisData}"]`).show();
    });

    let $selectedFilter = facultyStaffFilter.filter(':checked');

    if ($selectedFilter.length) {
      let $thisData = $selectedFilter.val();

      specificFilter.filter(`[data-specific="${$thisData}"]`).show();
    }

    $filterForm.on('submit', function (e) {
      e.preventDefault();
    });
  });
};